import { useContext } from "react";
import KpiContext from "../context/kpiProvider";

const useKpiTabs = () => {
  const { tabs, setTabs } = useContext(KpiContext);

  return {
    tabs,
    setTabs,
  };
};

export default useKpiTabs;
